import {
  useEffect 
} from "react"
import Cookie from "js-cookie"
import {
  BrowserPersistence 
} from "@/util"
import {
  getSearchParam 
} from "@/common/hooks/useSearchParam"
import {
  useSearchParams 
} from "next/navigation"

const storage = new BrowserPersistence()

export function useCJTracking() {
  const searchParams = useSearchParams()

  useEffect(() => {
    const cjevent = getSearchParam("cjevent", searchParams)

    if (cjevent) {
      storage.setItem("cjevent", cjevent)
      Cookie.set("cje", cjevent)
    }
  }, [searchParams])
}
